<template>
  <div class="row">
    <!-- heading & button -->
    <div class="col-lg-12 col-md-6">
      <div class="row">
        <div class="col-lg-2">
          <h3 class="card-title brightness">
            <!-- <p class="category">Default</p> -->

            <!-- Add User modal -->
            <modal
              :show.sync="modals.notice"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Add User Form</h3>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <form @submit.prevent>
                      <div>
                        <base-input
                          v-model="user.name"
                          type="text"
                          label="Full Name"
                          placeholder="Full Name"
                        ></base-input>
                        <base-input
                          v-model="user.email"
                          label="Email"
                          placeholder="Email"
                        ></base-input>
                        <base-input
                          v-model="user.phone"
                          type="number"
                          label="Phone Number"
                          placeholder="Phone Number"
                        ></base-input>
                        <base-input
                          v-model="user.password"
                          type="password"
                          label="Password"
                          placeholder="Password"
                        ></base-input>

                        <base-input
                          label="Access Level"
                          placeholder="Access Level"
                        >
                          <el-select
                            class="select-default"
                            size="large"
                            placeholder="Choose..."
                            v-model="user.role"
                          >
                            <el-option
                              v-for="role in user.rolename"
                              class="select-success"
                              :value="role.value"
                              :label="role.label"
                              :key="role.rolename"
                            ></el-option>
                          </el-select>
                        </base-input>

                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click.native="addUser()"
                          >Add</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.notice = false"
                          >Cancel</base-button
                        >
                        <!-- <p v-html="message" style="color: red"></p> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div slot="footer" class="justify-content-center"></div>
            </modal>

            <div slot="footer"></div>
          </h3>
        </div>
      </div>
      <!-- </template> -->
      <!-- </card> -->
    </div>
    <div class="col-md-12 text-center text-md-left">
      <card>
        <!-- <template slot="header">
            <h5 class="card-category">Navigation Pills</h5>
            <h3 class="card-title">Horizontal Tabs</h3>
        </template>-->

        <!-- <tabs type="primary"> -->
        <!-- <tab-pane label="User List"> -->
        <!-- <div style="text-align: right" > -->
        <base-button type="success" @click.native="modals.notice = true"
          >Add User</base-button
        >
        <!-- </div> -->
        <!-- Devices -->
        <hr />
        <div class="col-lg-12 col-md">
          <h3 class="card-title brightness">
            <div>
              <div
                class="
                  col-12
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <el-select
                  class="
                    select-primary
                    mb-3
                    pagination-select
                    d-none d-sm-block
                  "
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>

                <base-input type="success">
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Search records"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  ></el-input>
                </base-input>
              </div>
              <el-table
                :data="queriedData"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'transparent',
                  'padding-bottom': '0%',
                  'padding-center': '10px',
                  color: 'white',
                }"
                :cell-style="{
                  border: 'transparent',
                  'padding-center': '20px',
                }"
              >
                <!-- <el-table-column label="#"></el-table-column> -->
                <!-- Username -->
                <el-table-column
                  min-width="150"
                  sortable
                  label="Username"
                  property="username"
                ></el-table-column>
                <!-- Email -->
                <el-table-column
                  min-width="150"
                  sortable
                  label="User Email"
                  property="useremail"
                ></el-table-column>
                <!-- Telephone -->
                <el-table-column
                  min-width="150"
                  sortable
                  label="User Phone"
                  property="userphone"
                ></el-table-column>
                <!-- Date Updated -->
                <el-table-column
                  min-width="150"
                  sortable
                  align="right"
                  header-align="right"
                  label="Updated At"
                  property="UpdatedAt"
                ></el-table-column>
                <!-- User Access -->
                <el-table-column
                  min-width="150"
                  sortable
                  align="right"
                  header-align="right"
                  label="Access Level"
                  property="rolename"
                ></el-table-column>
                <el-table-column :min-width="100" align="right" label="Actions">
                  <div slot-scope="props">
                    <el-tooltip
                      content="Edit"
                      placement="bottom"
                      effect="light"
                    >
                      <base-button
                        @click.native="modals.edit = true"
                        @click="getRow(props.row)"
                        class="edit btn-link"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-pencil"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Delete"
                      placement="bottom"
                      effect="light"
                    >
                      <base-button
                        @click.native="handleDelete(props.$index, props.row)"
                        class="remove btn-link"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-simple-remove"></i>
                      </base-button>
                    </el-tooltip>
                    <modal
                      :show.sync="modals.edit"
                      footer-classes="justify-content-center"
                      type="notice"
                    >
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form @submit.prevent>
                              <div class="row justify-content-center mt-12">
                                <div class="col-sm-12">
                                  <div>
                                    <h3 style="color: #344675">
                                      User Information
                                    </h3>
                                    <base-input
                                      v-model="user.name"
                                      type="text"
                                      label="Username"
                                      placeholder="Username"
                                    ></base-input>
                                    <base-input
                                      v-model="user.email"
                                      label="Email"
                                      placeholder="Email"
                                    ></base-input>
                                    <!-- <base-input
                                      v-model="user.password"
                                      type="password"
                                      label="Password"
                                      placeholder="Password"
                                    ></base-input>-->
                                    <base-input
                                      v-model="user.phone"
                                      type="number"
                                      label="Phone Number"
                                      placeholder="Phone Number"
                                    ></base-input>
                                    <base-input
                                      label="Access Level"
                                      placeholder="Access Level"
                                    >
                                      <el-select
                                        class="select-default"
                                        size="large"
                                        placeholder="Choose..."
                                        v-model="user.role"
                                      >
                                        <el-option
                                          v-for="role in user.rolename"
                                          class="select-success"
                                          :value="role.value"
                                          :label="role.label"
                                          :key="role.rolename"
                                        ></el-option>
                                      </el-select>
                                    </base-input>
                                  </div>
                                </div>
                                <div>
                                  <base-button
                                    class="mt-3"
                                    native-type="submit"
                                    type="success"
                                    @click.native="handleEdit()"
                                    >Submit</base-button
                                  >
                                  <base-button
                                    class="mt-3"
                                    type="danger"
                                    @click.native="modals.edit = false"
                                    >Cancel</base-button
                                  >
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </modal>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <div class>
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <base-pagination
                type="success"
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              ></base-pagination>
            </div>
          </h3>
        </div>
        <!-- </tab-pane> -->
        <!-- </tabs> -->
      </card>
    </div>

    <!-- <div class="col-lg-5">
      
    </div>
    <div class="col-lg-7">
      
    </div>-->
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Slider, BaseSwitch } from "src/components/index";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import { TabPane, Tabs, Collapse, CollapseItem } from "src/components";
import users from "./users"; //read users from this file
import Fuse from "fuse.js";
import moment from "moment";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      message: "",
      users: [],
      accessList: [],
      user: {
        name: "",
        useremail: "",
        rolename: [],
        rolescopes: "",
        accessLevel: "",
        CompanyID: "",
        CreatedAt: "",
        UpdatedAt: "",
        DeletedAt: "",
        phone: "",
        role: "",
        roleid: "",
        password: "",
      },
      selects: {
        simple: "",
      },
      datePicker: "",
      modals: {
        notice: false,
        upload: false,
        edit: false,
      },
      pagination: {
        perPage: 5,
        currentPage: 0,
        perPageOptions: [5, 10, 25, 50], //default value for dropdown
        total: 0, //akan berubah dalam method nnt
      },
      searchQuery: "",
      propsToSearch: ["searchQuery", "signal strength"],
      tableColumns: [
        {
          prop: "fullname",
          label: "Full Name",
          // minWidth: 200
        },
        {
          prop: "email",
          label: "Email",
          // minWidth: 250
        },
        {
          prop: "site",
          label: "Site",
          // minWidth: 250
        },
        {
          prop: "password",
          label: "Password",
          // minWidth: 250
        },
        {
          prop: "accesslevel",
          label: "Access Level",
          minWidth: 100,
        },
        // {
        //   prop: 'age',
        //   label: 'Age',
        //   minWidth: 100
        // },
        // {
        //   prop: 'salary',
        //   label: 'Salary',
        //   minWidth: 120
        // }
      ],
      searchedData: [],
      fuseSearch: null,
      getRowData: "",
    };
  },
  computed: {
    queriedData() {
      let result = this.users;
      console.log(result);
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.users.length;
    },
    bigLineChartCategories() {
      return [
        { name: "Accounts", icon: "tim-icons icon-single-02" },
        { name: "Purchases", icon: "tim-icons icon-gift-2" },
        { name: "Sessions", icon: "tim-icons icon-tap-02" },
      ];
    },
  },
  methods: {
    deleteRowFromTable(index) {
      console.log(index);
      for (var i = 0; i < this.queriedData.length; i++) {
        if (index === this.queriedData[i].userid) {
          this.queriedData.splice(i, 1);
          console.log(this.queriedData);
        }
      }
      console.log(index);
    },
    getAccessList() {
      this.user.rolename = []
      let _accessList = [];

      return this.$http
        .get(":8002/api/v1/admin/access")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            let data = JSON.parse(JSON.stringify(res.message.acl_list));
            console.log(data);
            for (let i = 0; i < data.length; i++) {
              this.accessList.push(data[i]);
              console.log(data[i].rolename);
              let obj = {};
              obj["label"] = data[i].rolename;
              obj["value"] = data[i].roleid;
              this.user.rolename.push(obj);
              _accessList.push(obj);
            }
            return _accessList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUserList() {
      this.users = [];

      this.$http
        .get(":8002/api/v1/admin/user")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.$router.push("/dashboard");
          } else {
            let _accessList = this.getAccessList();

            _accessList.then((response) => {
              let data = res.message.users_list;
              for (let i = 0; i < data.length; i++) {
                data[i].CreatedAt = moment(data[i].CreatedAt)
                  .format("LLL")
                  .toString();
                data[i].UpdatedAt = moment(data[i].UpdatedAt)
                  .format("LLL")
                  .toString();

                for (let j = 0; j < response.length; j++) {
                  if (data[i].roleid === response[j].value) {
                    data[i]["rolename"] = response[j].label;
                  }
                }
                this.users.push(data[i]);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addUser() {
      // email must follow below format
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      console.log(re.test(this.user.email));

      if (re.test(this.user.email) === false) {
        swal({
          type: "error",
          title: "Oops... Wrong format email!",
        });
        // check form
        console.log(this.user.name);
        if (this.user.name === "") {
          console.log("username empty");
          swal({
            type: "error",
            title: "Oops... username empty!",
          });
        }

        if (this.user.email === "") {
          swal({
            type: "error",
            title: "Oops... email empty!",
          });
        }

        if (this.user.phone === "") {
          swal({
            type: "error",
            title: "Oops... phone number empty!",
          });
        }

        if (this.user.password === "") {
          swal({
            type: "error",
            title: "Oops... password empty!",
          });
        }

        if (this.user.role === "") {
          swal({
            type: "error",
            title: "Oops... please select role!",
          });
        }
      } else {
        let payload = {
          username: this.user.name,
          useremail: this.user.email,
          userpass: this.user.password,
          userphone: this.user.phone,
          roleid: this.user.role,
        };

        console.log(payload);
        //  this.user.role contain role id
        // create another payload to push to the table
        // 1. compare id to called role name

        console.log(this.users);
        console.log(this.accessList);
        console.log(this.user.role);
        console.log(this.accessList);
        console.log(this.user.role);

        var rolename = "";
        var updatedAt = "";
        for (var i = 0; i < this.accessList.length; i++) {
          if (this.user.role === this.accessList[i].roleid) {
            console.log("matched!!!");
            rolename = this.accessList[i].rolename;
            updatedAt = moment().format("LLL").toString();
          }
        }

        let payloadTable = {
          username: this.user.name,
          useremail: this.user.email,
          userpass: this.user.password,
          userphone: this.user.phone,
          rolename: rolename,
          UpdatedAt: updatedAt,
        };
        console.log(payload);

        this.$http
          .post(":8002/api/v1/admin/user", payload)
          .then((res) => {
            if (res.error) {
              swal({
                type: "error",
                title: res.message,
              });
              // this.message = res.message;
              // console.log(res.message);
            } else {
              //login OK!
              console.log(res);
              swal({
                type: "success",
                title: "New User Added! You've added "+ this.user.name ,
              });
              this.getUserList();
              // this.queriedData.push(payloadTable);
              // console.log(this.queriedData);
              // console.log(this.users);
              // this.users.push(payloadTable)

              this.user.name = "";
              this.user.email = "";
              this.user.phone = "";
              this.user.password = "";
              this.user.role = "";
              this.modals.notice = false;
              // this.message = res.message;
              // this.tableData = res.message.users_list;
            }
          })
          .catch((err) => {
            console.log(err);
          });

        let verticalAlign = "bottom";
        let horizontalAlign = "right";

        let color = Math.floor(Math.random() * 4 + 1);
      }
    },
    getRow(row) {
      console.log(row);
      this.getRowData = row;

      (this.user.name = `${row.username}`),
        (this.user.email = `${row.useremail}`),
        (this.user.password = `${row.userpass}`),
        (this.user.phone = `${row.userphone}`),
        (this.user.role = `${row.rolename}`),
        (this.user.roleid = `${row.roleid}`),
        (this.user.UpdatedAt = `${row.UpdatedAt}`);
    },
    editUser() {
      let updateDate = new Date();

      let payload = {
        username: this.user.name,
        useremail: this.user.email,
        userpass: this.user.password,
        userphone: this.user.phone,
        roleid: this.user.roleid,
        rolename: this.user.role,
      };
      // payload baru untuk display data dekat table sebab haziq tak bagi hantar timestamp tp kat table ada timestamp
      // let payloadToDisplayInTable = {
      //   username: this.user.name,
      //   useremail: this.user.email,
      //   userpass: this.user.password,
      //   userphone: this.user.phone,
      //   roleid: this.user.roleid,
      //   rolename: this.user.role,
      //   UpdatedAt: this.user.UpdatedAt
      // };

      // baca id and compare with users array and replace the value here
      // console.log(this.getRowData.userid);
      // for (var i = 0; i < this.users.length; i++) {
      //   console.log(this.users[i]);
      //   if (this.getRowData.userid === this.users[i].userid) {
      //     console.log("hi");
      //     // push new value to the index
      //     this.users[i] = payloadToDisplayInTable;
      //     this.queriedData[i] = payloadToDisplayInTable;
      //   } else {
      //     // do nothing
      //     console.log("nothing changed!!");
      //   }
      // }

      // this.users.push(payload)
      // console.log(payload.UpdatedAt);

      this.$http
        .post(":8002/api/v1/admin/user/edit/" + this.getRowData.userid, payload)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
            console.log(res);
            this.message = res.message;
            this.users = [];
            this.getUserList();
          }
        })
        .catch((err) => {
          console.log(err);
        });

      let verticalAlign = "bottom";
      let horizontalAlign = "right";

      let color = Math.floor(Math.random() * 4 + 1);
      this.modals.edit = false;

      (this.user.name = ""),
        (this.user.email = ""),
        (this.user.password = ""),
        (this.user.phone = ""),
        (this.user.role = ""),
        (this.user.roleid = "");
    },
    handleEdit() {
      swal({
        title: "Are you sure?",
        text: `You want to edit ${this.getRowData.username}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editUser();
          swal({
            title: "Edited!",
            text: `You edited ${this.getRowData.username}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    handleDelete(index, row) {
      console.log(row);
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.username}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      console.log(row);
      console.log(row.userid);
      this.$http
        .delete(":8002/api/v1/admin/user/" + row.userid, null)
        .then((res) => {
          if (!res.error) {
            //login OK!
            console.log(res.message);
            this.message = res.message;

            // this.deleteRowFromTable(row.userid);
            this.getUserList();
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // let verticalAlign = "bottom";
      // let horizontalAlign = "right";

      // let color = Math.floor(Math.random() * 4 + 1);
      // this.modals.edit = false;

      // this.user.name = "",
      // this.user.email = "",
      // this.user.password = "",
      // this.user.phone = "",
      // this.user.role = "",
      // this.user.roleid = ""

      // let indexToDelete = this.users.findIndex(
      //   tableRow => tableRow.id === row.id
      // );
      // if (indexToDelete >= 0) {
      //   this.users.splice(indexToDelete, 1);
      // }
    },
  },
  mounted() {
    // this.getAccessList();
    this.getUserList();
    console.log(this.accessList);
    console.log(this.users);

    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.users, {
      keys: ["username", "email"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.users;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.head h3 {
  display: inline;
  padding-bottom: 10px;
}
.brightness p {
  display: inline;
}
.bright slider {
  display: inline;
}
.chartButton {
  text-align: right;
}
</style>
